//依赖app.js
var serach = {
    recName:'serachRed', //cookie中的名字
    searchTypeUrl: '', //searchTypeUrl
    //搜索
    do: function (e) {
        var _this  = this;
        var evt = window.event || e;
        if (evt.keyCode === 13) {
            var searchInput = document.getElementById('serach-input');
            var keyWord = searchInput.value;
            //去左右空格;
            keyWord = keyWord.replace(/(^\s*)|(\s*$)/g, "");
            if (!keyWord) {
                searchInput.classList.add('has-error');
                return;
            } else {
                searchInput.classList.remove('has-error');
            }
            // if (!keyWord) {
            //     return;
            // }else{
            _this.saveRec(keyWord);
            gioEvarAction.searchEvar(keyWord);
            userRecode({behaviorType: '搜索', behaviorResult: '搜索关键词'});
            var locationsearch =  window.location.search;
            if (getUrlPara('ishot') && parseInt(getUrlPara('ishot'))) {
                // 手动搜索
                // search ishot 为 1
                // 改为 ishot=0
                locationsearch = common.changeUrlParams('ishot',locationsearch, 0);
            }
            if (getUrlPara('pn')) {
                locationsearch = common.changeUrlParams('pn',locationsearch, 1);
            }
            var searchUrl = '';
            if (locationsearch.indexOf('kw') > -1){
                locationsearch = common.changeUrlParams('kw',locationsearch, keyWord);
                searchUrl = '/list' + locationsearch + this.searchTypeUrl
            }else {
                searchUrl = '/list' + locationsearch + this.searchTypeUrl + "&kw=" + keyWord
            }

            if(searchUrl.indexOf('searchmodule') > -1){
                searchUrl = common.changeUrlParams('searchmodule', searchUrl, window.cateData.userRecodeOption.module);
            }else{
                searchUrl = searchUrl + '&searchmodule=' + window.cateData.userRecodeOption.module;
            }

            window.location.href = searchUrl;
        }
    },

    setSearchTypUrl: function(){
        if(window.location.search){
            this.searchTypeUrl = '&type=' + window.cateData.searchType;
        }else{
            this.searchTypeUrl = '?type=' + window.cateData.searchType;
        }

        if( window.location.search.indexOf('type=') > -1){
            this.searchTypeUrl = '';
        }
    },

    doSearch: function(keyWord, ishot) {
        var searchInput = document.getElementById('serach-input');
        searchInput.value = keyWord;
        this.saveRec(keyWord);
        userRecode({behaviorType: '搜索', behaviorResult: '搜索关键词'});
        var search = window.location.search;
        if (ishot){
            // 热门搜索
            if (getUrlPara('ishot') && parseInt(getUrlPara('ishot')) == 1) {
                // search ishot 为 1
            }else if(getUrlPara('ishot') && parseInt(getUrlPara('ishot')) == 0){
                // search ishot 为 0  要改为1
                search = common.changeUrlParams('ishot', search, ishot);
            }else{
                // search 中没有ishot字段
                search += '&ishot=' + ishot;
            }
        }else  if (getUrlPara('ishot') && parseInt(getUrlPara('ishot'))) {
            // 手动搜索
            // search ishot 为 1
            // 改为 ishot=0
            search = common.changeUrlParams('ishot',search, 0);
        }
        if (getUrlPara('pn')) {
            search = common.changeUrlParams('pn',search, 1);
        }
        console.log(search);
        gioEvarAction.searchEvar(keyWord);
        var searchUrl = ''
        if (search.indexOf('kw') > -1){
            search = common.changeUrlParams('kw',search, keyWord);
            searchUrl = '/list'  + this.searchTypeUrl + search
        }else {
            searchUrl = '/list'  + this.searchTypeUrl + search + "&kw=" + keyWord;
        }

        if(searchUrl.indexOf('searchmodule') > -1){
            searchUrl = common.changeUrlParams('searchmodule', searchUrl, window.cateData.userRecodeOption.module);
        }else{
            searchUrl = searchUrl + '&searchmodule=' + window.cateData.userRecodeOption.module;
        }

        window.location.href = searchUrl;
    },

    //保存记录
    saveRec: function(keyWord){
        var rec = getCookie(this.recName);
        if(!rec){
            rec = [];
        }else{rec = rec.split(",");
        }
        if (rec.indexOf(keyWord) != -1) {
            rec.splice(rec.indexOf(keyWord), 1);
        }
        rec.unshift(keyWord);
        setCookie(this.recName, rec);
    },

    //清空记录
    clearRec: function () {
        setCookie(this.recName, '');
        document.querySelector('.recent-search').innerHTML = '';
        document.querySelector('.recent-search-box').remove();
    },

    //设置记录
    setRec: function () {
        var rec = getCookie(this.recName);
        if(!rec){
            var searchBox = document.querySelector('.recent-search-box');
            if (searchBox) {
                searchBox.remove();
            }
            return;
        }
        rec = rec.split(",")
        var _this = this;
        rec.forEach(function (item, index){
            var node=document.createElement("li");
            var link=document.createElement("a");
            var textnode=document.createTextNode(item);
            var search = window.location.search;
            if (getUrlPara('ishot')) {
                search = common.changeUrlParams('ishot', search,  0);
            }
            if (getUrlPara('pn')) {
                search = common.changeUrlParams('pn',search, 1);
            }
            if (search.indexOf('kw') > -1){
                search = common.changeUrlParams('kw',search,  item);
                link.href =  '/list' + search + _this.searchTypeUrl;
            }else {
                link.href =  '/list' + search + _this.searchTypeUrl + "&kw=" + item;
            }
            var searchUrl = '';
            if(link.href .indexOf('searchmodule') > -1){
                searchUrl = common.changeUrlParams('searchmodule', link.href, window.cateData.userRecodeOption.module);
            }else{
                searchUrl = link.href + '&searchmodule=' + window.cateData.userRecodeOption.module;
            }
            link.href = searchUrl;
            link.appendChild(textnode);
            node.appendChild(link);
            (function (kw) {
                var kw = kw;
                node.addEventListener('click', function () {
                    gioEvarAction.searchEvar(kw);
                })
            })(item)
            if(item !== rec[index-1]){
                document.querySelector('.recent-search').appendChild(node);
            }
        });

    },

    addClick: function(){
        var serachEle = document.querySelector('.page-home-serach-bt'); //首页搜索按钮
        var cancelEle = document.querySelector('.cancelbt');
        var serachPage = document.querySelector('.page-serach');
        var serachInput = document.querySelector('#serach-input');
        var pageHome = document.querySelector('.page-home');

        if(serachEle){
            serachEle.addEventListener('click', function(){
                serachPage.style.display = 'block';
                serachInput.focus();
                // pageHome.style.display = 'none';
            });
        }
        if (cancelEle) {
            cancelEle.addEventListener('click', function () {
                serachPage.style.display = 'none';
                pageHome.style.display = 'block';
            });
        }
    },

    searchResultClick: function(url) {
        event.stopPropagation();
        var searchSource = common.getSearchSourceType();

        var paths = window.location.pathname.split('/');
        var kw = decodeURIComponent(common.getUrlPara('kw'));

        gioTrackAction.searchResultClick(kw, searchSource, window.cateData.searchReusltType);
        var newurl = url;
        if (url.split('?').length > 1){
            newurl = newurl + '&sw=' + decodeURI(paths[paths.length - 1]);
        } else {
            newurl = newurl + '?sw=' + decodeURI(paths[paths.length - 1]);
        }

        newurl = common.getLocalUrl(newurl);

        newurl = common.changeUrlParams('searchmodule', newurl, window.cateData.userRecodeOption.module);
        window.location.href = newurl;

    },

    /*加入购物车*/
    doCartWap: function(id) {
    var loginInfo = common.isLogin();
    if(loginInfo){
        var formData = new FormData();
        formData.append('quantity', 1);
        formData.append('product_id', id);
        formData.append('OCSESSID', common.getCookie('OCSESSID') || '');
        $.ajax({
            url: eshop_host + "/index.php?route=api/cart/add",
            type: "post",
            data: formData,
            dataType: "json",
            contentType: false,
            processData: false,
            mimeType: "multipart/form-data",
            success: function (res) {
                msg.toast(res.success);
            },
            error: function (data) {
                msg.toast( '操作失败，请稍后再试');
            }
        });
    }else {
        var backUrl = window.location.href;
        var url = solution_host + '/account/login?backUrl=' + encodeURIComponent(backUrl);
        window.location.href = url;
    }
},

    // 搜索 gio 埋点
    gioForSearchResult: function(){

        var searchSuccess = '否';
        var searchSource = common.getSearchSourceType();
        if (searchTotalData && parseInt(searchTotalData)) {
            // 搜索成功，有数据
            searchSuccess = '是'
        }

        var kw = decodeURIComponent(common.getUrlPara('kw'));
        var searchModule = decodeURIComponent(common.getUrlPara('searchmodule')) || window.cateData.userRecodeOption.module || '站内搜索';
        gioTrackAction.search(kw, searchSuccess, searchSource, searchModule);
    },

    init: function () {
        if(!document.querySelector('.page-serach')){
            return;
        }
        this.setSearchTypUrl();
        this.setRec();
        this.addClick();
    },

    clearSearch:function () {
        if($('#serach-input').val().length>0){
            $('#serach-input').val('');
        }else {
            goBack()
        }

    }


};

serach.init();
